var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"transform":("translate(0, " + _vm.margin + ")")}},[_c('text',{attrs:{"x":_vm.text_x,"y":_vm.text_y,"dy":_vm.dy}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }